import $ from "jquery";

/*FILTER*/
const filter = $('#filter');
const filterBtn = $('.submit-btn');
const clearBtn = $('.clear-btn');
const loadMore = $('.load-more-link');
const totalCount = $('.button-wrapper').data('total-count');
const loadFunction = function() {
    $.ajax({
        url: filter.attr('action'),
        data: filter.serialize() + "&offset=0",
        type: filter.attr('method'),
        offset: 0,
        beforeSend: function () {
            $('.posts-listing-block__posts .item').fadeOut(600);
        },
        success: function (data) {
            let $data = $(data);
            $('.posts-listing-block__posts').html($data);
        },
        complete: function () {
            $('.posts-listing-block__posts .item').fadeIn(250);
            let foundPostsCount = $('.found-posts').data('found-posts');
            clearBtn.addClass('active');
            doubleCheckonFilterFunction(foundPostsCount);
        },
    });
};

const loadMoreFunction = function() {
    $.ajax({
        url: filter.attr('action'),
        data: filter.serialize() + "&offset=" + $('.posts-listing-block__posts .item').length,
        type: filter.attr('method'),
        success: function (data) {
            let $data = $(data);
            $('.posts-listing-block__posts').append($data);
        },
        complete: function () {
            $('.posts-listing-block__posts .item').fadeIn(250);
            doubleCheckFunction();
        },
    });
};

const doubleCheckFunction = function() {
    if(totalCount === $('.posts-listing-block__posts .item').length) {
        setTimeout(function() { 
            loadMore.hide();
        }, 300);
    }
}

const doubleCheckonFilterFunction = function(foundPostsCount) {
    if(foundPostsCount != undefined) {
        if(foundPostsCount > $('.posts-listing-block__posts .item').length) {
            loadMore.show();
            clearBtn.removeClass('active');
        } else {
            loadMore.hide();
        }
    }
}

filterBtn.on('click', function (e) {
    e.preventDefault();
    loadFunction();
});

clearBtn.on('click', function (e) {
    e.preventDefault();
    $('select[name="town"]').val('all');
    $('select[name="category"]').val('all');
    loadFunction();
    clearBtn.removeClass('active');
});

loadMore.on('click', function (e) {
    e.preventDefault();
    if(totalCount > $('.posts-listing-block__posts .item').length) {
        loadMoreFunction();
    } else {
        loadMore.hide();
    }
});